import { SIZES } from "@/lib/api";

const uid = () => Math.random().toString(36).slice(2);

export const emptySoleLine = (block = uid(), code = "") => ({ id: uid(), block, code, color: "", colorSet: false, sizes: {} });

export const soleLinesTotal = (lines) =>
  lines.reduce((a, l) => a + Object.values(l.sizes).reduce((x, y) => x + (parseInt(y) || 0), 0), 0);

// /soles/shortage rows -> one form line per sole code+color
export const shortageToLines = (rows) => {
  const map = new Map();
  rows.forEach((x) => {
    const k = `${x.sole_code}||${x.sole_color}`;
    if (!map.has(k)) map.set(k, { ...emptySoleLine(`c-${x.sole_code}`, x.sole_code), color: x.sole_color || "", colorSet: true, sizes: {} });
    map.get(k).sizes[x.size] = x.missing;
  });
  return [...map.values()];
};

// Form lines -> API items, or a user-facing error
export const soleOrderItems = (lines) => {
  const items = [];
  for (const l of lines) {
    if (!l.code) return { error: "Her kalem için taban kodu seçin" };
    if (!l.colorSet) return { error: `${l.code}: taban rengi seçin` };
    SIZES.forEach((s) => {
      const q = parseInt(l.sizes[s]) || 0;
      if (q > 0) items.push({ sole_code: l.code, sole_color: l.color, size: s, qty: q });
    });
  }
  return items.length ? { items } : { error: "En az bir numara için adet girin" };
};

// Saved sole order items -> form lines (one per code+color)
export const orderToSoleLines = (items) => {
  const map = new Map();
  items.forEach((i) => {
    const k = `${i.sole_code}||${i.sole_color || ""}`;
    if (!map.has(k)) map.set(k, { ...emptySoleLine(`c-${i.sole_code}`, i.sole_code), color: i.sole_color || "", colorSet: true, sizes: {} });
    map.get(k).sizes[i.size] = i.qty;
  });
  return map.size ? [...map.values()] : [emptySoleLine()];
};
